import groupBy from 'lodash/groupBy'
import map from 'lodash/map'
import React, { createContext, VFC } from 'react'

import { LinkedProducts } from '@Components/Product/Linked/LinkedProducts'
import { LinkedProduct } from '@Globals/CMS/ProductHelpers'

export interface LinkedProductsProps {
  data: LinkedProduct[]
  selectedID?: string
}

export const LinkedProductParentIDContext = createContext('')

export const LinkedProductList: VFC<LinkedProductsProps> = ({ data, selectedID }) => (
  <LinkedProductParentIDContext.Provider value={selectedID || ''}>
    {map(groupBy(data, 'type'), (products, type) => (
      <LinkedProducts
        key={type}
        products={products}
        type={type}
      />
    ))}
  </LinkedProductParentIDContext.Provider>
)

